import PoolsApi from '../api/pools'
import { push } from 'react-router-redux'
import { addInfoNotification, addErrorNotification } from './notifications'
import { HIDE_MODAL } from './modal'

export const DELETE_POOL = 'DELETE_POOL'

export const deletePool = (id) => {
  return dispatch => {

    dispatch({
      type: HIDE_MODAL
    })

    PoolsApi.DeletePool(id)
      .then(() => {
        dispatch(addInfoNotification('Pool Deleted'))
        dispatch(push('/pools'))
      })
      .catch(error => {
        dispatch(addErrorNotification('Error deleting pool', error.message))
        console.log('Catch fetch error: ', error)
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/poolDelete.js